const parseBookClubDate = (value) => {
  if (!value) {
    return null;
  }

  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
};

const addMonths = (date, amount) => {
  const next = new Date(date);
  const originalDay = next.getDate();

  next.setDate(1);
  next.setMonth(next.getMonth() + amount);
  const lastDay = new Date(
    next.getFullYear(),
    next.getMonth() + 1,
    0
  ).getDate();
  next.setDate(Math.min(originalDay, lastDay));

  return next;
};

export const getBookClubCountdownParts = (startsAt, now = new Date()) => {
  const start = parseBookClubDate(startsAt);
  if (!start || start <= now) {
    return null;
  }

  let months = Math.max(
    0,
    (start.getFullYear() - now.getFullYear()) * 12 +
      start.getMonth() -
      now.getMonth()
  );
  let cursor = addMonths(now, months);

  while (months > 0 && cursor > start) {
    months -= 1;
    cursor = addMonths(now, months);
  }

  const remainingSeconds = Math.ceil(
    (start.getTime() - cursor.getTime()) / 1000
  );
  const days = Math.floor(remainingSeconds / (24 * 60 * 60));
  const hours = Math.floor((remainingSeconds % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((remainingSeconds % (60 * 60)) / 60);
  const seconds = remainingSeconds % 60;

  return { months, days, hours, minutes, seconds };
};

export const formatBookClubCountdown = (startsAt, now = new Date()) => {
  const parts = getBookClubCountdownParts(startsAt, now);
  if (!parts) {
    return null;
  }

  if (parts.months > 0) {
    return `${parts.months}mo ${parts.days}d`;
  }

  if (parts.days > 0) {
    return `${parts.days}d ${parts.hours}h`;
  }

  if (parts.hours > 0) {
    return `${parts.hours}h ${parts.minutes}m`;
  }

  return `${parts.minutes}m`;
};
